import React, { useMemo } from "react";
import {
  ButtonsContainer,
  Card,
  UserInfo,
  UserTextData,
} from "../../../../components/EditUserCard/styles";
import Avatar from "../../../../components/Avatar";
import { useRecoilState } from "recoil";
import userState from "../../../../states/userState";
import awsRoot from "../../../../utils/awsRoot";
import userImg from "../../../../assets/imgs/user.png";
import Button from "../../../../components/Button";
import { User } from "../../../../interfaces/User";

type Props = { user: User; onClick: () => void };

export default function SelectCard({ user, onClick }: Props) {
  const [loggedUser] = useRecoilState(userState);

  const towerLabel =
    loggedUser?.residential?.labelType !== "house" ? "Torre" : "Rua";
  const aptLabel =
    loggedUser?.residential?.labelType === "house"
      ? "Casa"
      : loggedUser?.residential?.labelType === "commercial"
      ? "Sala"
      : "Apt";

  const residentLabel =
    loggedUser?.residential?.labelType !== "commercial"
      ? "Morador"
      : "Pessoa interna";

  const fullName = `${user.name ?? ""} ${user.surname ?? ""}`;
  const photo = user.imageUUID
    ? `${awsRoot}users_images/` + user.imageUUID + ".jpg"
    : userImg;

  const residentTypeLabels = useMemo(
    () => ({
      owner: "Proprietário",
      tenant:
        user?.residential?.labelType === "commercial"
          ? "Locatário"
          : "Inquilino",
      employee: "Funcionário",
    }),
    [user?.residential?.labelType]
  );

  return (
    <Card>
      <UserInfo>
        <Avatar
          src={photo}
          alt={`Foto d${
            residentLabel === "Morador" ? "o" : "a"
          } ${residentLabel.toLocaleLowerCase()}`}
          size="sm"
        />
        <UserTextData>
          <h4>{fullName}</h4>
          {user.company && (
            <p>
              Empresa: <span>{user.company}</span>
            </p>
          )}
          {user.residentType && (
            <p>
              <span>{residentTypeLabels[user.residentType]}</span>
            </p>
          )}
          {user.condominium?.name &&
            user.condominium?.name !== user.tower?.name && (
              <p>
                Cond: <span>{user.condominium.name}</span>
              </p>
            )}
          {user.tower?.name && (
            <p>
              {towerLabel}: <span>{user.tower.name}</span>
            </p>
          )}
          {user.apartment?.name && (
            <p>
              {aptLabel}: <span>{user.apartment.name}</span>
            </p>
          )}
        </UserTextData>
      </UserInfo>
      <ButtonsContainer>
        <Button title="Selecionar" size="sm" onClick={onClick} />
      </ButtonsContainer>
    </Card>
  );
}
